import React, { useEffect, useState } from "react";
import { Card, Paper, Stack, Typography } from "@mui/material";
import WhatsappApiFunctions from "../../API/whatsapp";

export const DynamicTemplate = ({ template, image }) => {

    const templatePreviewData = template || {};
    console.log(image && JSON.parse(image).ImagePath);

    const [templatePreviewLoader, setTemplatePreviewLoader] = useState(false);
    // const [templatePreviewData, setTemplatePreviewData] = useState(template || {});
    const [previewStatus, setpreviewStatus] = useState('Fetching preview...');

    return (
        <Paper elevation={2} sx={{ background: 'white', width: "100%", borderRadius: "12px", }}  >
            <Stack p={2} sx={{ height: "60px", width: "100%", }} justifyContent='center'>
                <Typography>Template Preview</Typography>
            </Stack>
            <Stack p={2} sx={{ background: "#f3f3f3", height: 'calc(30rem - 60px - 16px)', overflowY: "scroll" }} className="Scrollbar" pr={'25%'}>
                <Paper sx={{ padding: "10px", width: "100%", margin: "0", borderRadius: "8px" }} elevation={1}>
                    {
                        template ?
                            (
                                templatePreviewLoader ?
                                    <Typography sx={{ color: "grey" }}> {previewStatus}</Typography>
                                    :
                                    (Object.keys(templatePreviewData).length > 0 &&
                                        <>
                                            <Card className="header">
                                                {image &&
                                                <img src={image && JSON.parse(image).ImagePath} alt="img"/> 
                                                }
                                                {template}
                                            </Card>
                                           
                                        </>
                                    )
                            )
                            :
                            <Typography sx={{ color: "grey" }}>Please select your template.</Typography>
                    }
                </Paper>
            </Stack>
        </ Paper>
    );
};

